import { styled } from '@mui/material'
import ItemHeader from 'containers/ManageAccess/ItemHeader'
import { isNilOrEmpty } from 'packages/core'
import { Drawer, Loader } from 'packages/eid-ui'

const StyledDrawer = styled(Drawer)({
    '& .MuiCardHeader-root': {
        borderRadius: '0',
    },
})

export const ManageAccessDrawer = ({
    id,
    toggleDrawer,
    item,
    itemDetails,
    headerAttribute,
}) => {
    return (
        <StyledDrawer
            width="clamp(67%, 1007px, 90%)"
            open={!isNilOrEmpty(id)}
            toggleDrawer={toggleDrawer}
            stickyHeader
            closeOnOutsideClick
            header={<ItemHeader title={item?.resource[headerAttribute.name]} />}
        >
            {!item && <Loader />}
            {item && itemDetails}
        </StyledDrawer>
    )
}
